import NGRhombus from 'src/styles/theme/components/NGRhombus';
import { ERhombusType } from 'src/styles/theme/components/NGRhombus/NGRhombus.enum';
import { EPosition, ESize } from 'src/styles/theme/utils/enums';

import { FC } from 'react';
import { StyledNGSeparator } from './NGSeparator.styles';
import { INGSeparator } from './NGSeparator.type';

const NGSeparator: FC<INGSeparator> = ({
	rhombusSize = ESize.s,
	rhombusPosition = EPosition.center,
	marginSize = ESize['6xl'],
	...otherProps
}) => {
	return (
		<StyledNGSeparator rhombusPosition={rhombusPosition} marginSize={marginSize} {...otherProps}>
			<NGRhombus size={rhombusSize} type={ERhombusType.full} />
		</StyledNGSeparator>
	);
};

export { NGSeparator };
